var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderItem1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.112 2.88219L154.819 1.58896L153.526 0.295532L104.215 1.59317L52.2485 1.59317L2.94866 0.2958L1.65026 1.59421L0.351828 2.89263L1.6492 52.1925L1.6492 104.159L0.351563 153.47L1.64481 154.763L2.93806 156.056L52.2485 154.759H104.215L153.5 156.056L154.806 154.75L156.112 153.444L154.815 104.159V52.1925L156.112 2.88219ZM25.039 23.1555L24.1254 24.0693L23.2116 24.9829L24.1284 59.8192L24.1284 96.5323L23.2118 131.361L24.1291 132.279L25.0464 133.196L59.8753 132.279H96.5884L131.425 133.196L132.339 132.282L133.252 131.369L132.335 96.5323V59.8192L133.252 25.001L132.329 24.0785L131.407 23.156L96.5884 24.0723L59.8753 24.0723L25.039 23.1555Z",
    fill: "url(#paint0_radial_57_1383)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_57_1383",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.151 0.295511) rotate(161.116) scale(295.602 402.726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5219F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderItem1);
export default __webpack_public_path__ + "static/media/header-item-1.971267eadd3a411522ecfbc8848cdd47.svg";
export { ForwardRef as ReactComponent };